import React, { useEffect, useState } from 'react';
import SettingsHeader from 'pages/authenticated/layout/settingsLayout/settingsHeader/SettingsHeader';
import { useNavigate, useParams } from 'react-router-dom';
import TourModal from 'component/hoc/tour-modal/TourModal';
import { useTour } from 'app-context/tourContext/TourContext';
import styles from './FormResponses.module.scss';
import Container from 'component/atom/container/Container';
import SearchInput from 'component/atom/forms/input/searchInput/SearchInput';
import { useFetch } from 'hooks/useFetch';
import { formsEndpoints } from 'hooks/endpoints';
import Loader from 'component/atom/loader/Loader';
import ItemCard from 'component/atom/card/item-card/ItemCard';
import { usePost } from 'hooks/usePost';
import NoData from 'component/molecules/Table/TableComponents/NoData/NoData';

const FormResponses = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showModal } = useTour();
  const [search, setSearch] = useState('');
  const { mutate: deleteForm, isPending: isPendingDelete } = usePost();

  const {
    data: forms,
    isFetching,
    refetch: refetchForms,
  } = useFetch(
    ['forms', id],
    formsEndpoints.getForms,
    {
      enabled: !!id,
    },
    {
      pageSize: 9,
      pageNumber: 1,
      botId: id,
      searchBy: search,
    }
  );

  const rightButtons = [
    {
      label: 'New Form',
      type: 'plus',
      opicBackground: true,
      func: () => navigate(`/bot/new-form/${id}`),
      // className: styles['new-form-btn'],
    },
  ];

  const handleDelete = (form) => {
    deleteForm(
      {
        method: 'Delete',
        url: formsEndpoints?.deleteForm(form?.id),
      },
      {
        onSuccess: () => {
          refetchForms();
        },
      }
    );
  };

  useEffect(() => {
    refetchForms();
  }, [search]);

  return (
    <>
      <SettingsHeader title='Forms' rightButtons={rightButtons} />
      {/* <Container className={styles['form-responses-container']}> */}
      {!search && forms?.data?.totalCount === 0 ? null : (
        <SearchInput
          classname={styles['search']}
          inputClassName={styles['search-input']}
          value={search}
          onChange={(e, newValue) => setSearch(newValue)}
        />
      )}

      {isFetching && <Loader isComponent />}
      {!isFetching && forms?.data?.items?.length === 0 && (
        <div
          style={{
            height: '50vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <NoData />
        </div>
      )}
      <div className={styles['forms-container']}>
        {!isFetching &&
          forms?.data?.items.map((form) => (
            <ItemCard
              key={form.id}
              item={form}
              botId={id}
              refetch={refetchForms}
              handleDelete={handleDelete}
              isPendingDelete={isPendingDelete}
              deleteTitle='Delete Form'
              deleteSubText='Are you sure you want to delete this form? This action is permanent and cannot be undone. All data response through this form will also be removed.'
              handleEditClick={(itemId) =>
                navigate(`/bot/edit-form/${id}/${itemId}`)
              }
              viewText='View Responses'
              viewClick={(itemId) => navigate(`/bot/form/${id}/${itemId}`)}
              nameKey='formName'
            />
          ))}
      </div>
      {/* </Container> */}
      {showModal && <TourModal />}
    </>
  );
};

export default FormResponses;
